/*
 * @Copyright:
 * -----------------------------------------------------------------------------------
 *  Kingsoft Office Enterprise Cloud Services.
 *  Copyright (c) Kingsoft Office,All rights reserved.
 * -----------------------------------------------------------------------------------
 *
 * @Date: 2020-08-24 17:51:03
 * @Author: Kaven.D
 * @LastEditors: Kaven.D
 * @LastEditTime: 2020-09-24 11:36:49
 * @Description:
 */
import mutations from './mutations'
import { VISABEL, DIALOGDATA } from './constants'

export default {
  state: {
    [VISABEL]: false,
    [DIALOGDATA]: {
      companyName: '',
      companyId: '',
      openUrl: '',
    },
  },
  mutations,
}
